export default __webpack_public_path__ + "media/images/banners/bnr_tobu-662852f0300566f0518306b376ade7c8.png";